import { useCallback, useEffect, useMemo, useState } from 'react';
import { useIntl } from 'react-intl';
import logCustomRouteButtonClicked from '@alltrails/amplitude/events/logCustomRouteButtonClicked';
import { useClientNavigationPushState, useClientNavigationSearchParams } from '@alltrails/core/hooks/useClientNavigation';
import { useLanguageRegionCode } from '@alltrails/core/hooks/useLanguageRegionCode';
import { wrapUrlSafe } from '@alltrails/core/utils/wrapUrlSafe';
import Button from '@alltrails/denali/components/Button';
import IconButton from '@alltrails/denali/components/IconButton';
import useIsMobileSizedScreen from '@alltrails/denali/hooks/useIsMobileSizedScreen';
import Edit from '@alltrails/denali/icons/Edit';
import styles from './BuildCustomRouteButton.module.scss';

const BuildCustomRouteButton = () => {
  const intl = useIntl();
  const pushState = useClientNavigationPushState();
  const searchParams = useClientNavigationSearchParams();
  const languageRegionCode = useLanguageRegionCode();
  const isMobile = useIsMobileSizedScreen();
  const [showIconButton, setShowIconButton] = useState(false);

  const buttonText = intl.formatMessage({ defaultMessage: 'Build custom route' });

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowIconButton(true);
    }, 5000);

    return () => clearTimeout(timer);
  }, []);

  const returnTo = useMemo(() => {
    if (typeof window === 'undefined') {
      return undefined;
    }
    const currentPath = window.location.pathname + window.location.search;
    return encodeURIComponent(currentPath);
  }, []);

  const onButtonClick = useCallback(() => {
    logCustomRouteButtonClicked({ location: 'explore map' });

    pushState(wrapUrlSafe(`/explore/custom-routes/new?${searchParams.toString()}${returnTo ? `&returnTo=${returnTo}` : ''}`, languageRegionCode));
  }, [pushState, searchParams, languageRegionCode, returnTo]);

  return showIconButton || isMobile ? (
    <IconButton icon={{ Component: Edit }} onClick={onButtonClick} title={buttonText} variant="ghost" elevated />
  ) : (
    <Button
      className={styles.buildCustomRouteButton}
      icon={{ Component: Edit }}
      onClick={onButtonClick}
      title={buttonText}
      text={buttonText}
      variant="ghost"
      elevated
    />
  );
};

export default BuildCustomRouteButton;
